import { Injectable } from "@angular/core";
import { ApplicationHttpService } from "../../core/services/application-http.service";
import { Attachment, AttachmentGroup, DocumentType } from "../models/attachment.model";
import { Observable, Subject } from "rxjs";
import { Document } from "../models/document.model";

@Injectable()
export class AttachmentService {

    attachments: Attachment[] = [];
    loadAttachmentsSubject$ = new Subject<AttachmentGroup[]>();

    documents: Document[] = [];
    
    constructor(private http: ApplicationHttpService) {

    }
    
    getAttachments(id: number): Observable<Attachment[]> {
        return this.http.get<Attachment[]>(`attachment/${id}`);
    }

    getAttachment(applicationId: number, id: number): Observable<Blob> {
        return this.http.getFile(`attachment/download/${applicationId}/${id}`);
    }


    getEventAttachments(backOfficeApplicationId: number, postRegEventId: number): Observable<Attachment[]> {
        return this.http.get<Attachment[]>(`back-office-document/${backOfficeApplicationId}?backOfficePostRegEventId=${postRegEventId}`);
    }

    
    
    public loadAttachments(applicationId: number): void {
        this.attachments = [];
        this.getAttachments(applicationId).subscribe({
            next: (attachments) => {
                this.attachments = attachments;
                this.loadAttachmentsSubject$.next(this.groupByDocumentType(this.filterAttachments(attachments)));
            },
            error: (error) => {
                console.error('Error fetching attachments:', error);
                this.loadAttachmentsSubject$.next([]);
            }
        });
    }

    public setDocumentsForRegEntity(documents: Document[]) {
        this.documents = documents;
    }

    public getAttachmentById(id: number): Attachment | null {
        var result: Attachment | null = null;
        if (this.attachments.length > 0) {
            result = this.attachments.find(i => i.id == id) || null;
        }
        else if (this.documents.length > 0) {
            let doc = this.documents.find(i => i.id == id) || null;
            if (doc != null) {
                result = {
                    fileName: doc.fileName,
                    createdAt: doc.createdAt,
                    documentId: doc.id,
                    fileKey: doc.fileKey
                } as Attachment;
            }
        }
        return result;
    }
    
    
    filterAttachments(attachments: Attachment[]): Attachment[] {
        let exludedTypes = [DocumentType.PROOF_OF_PAYMENT, DocumentType.KYC_REPORT, DocumentType.KYC_IDENTITY_DOC,
            DocumentType.INCORPORATION_CERTIFICATE_DOCUMENT, DocumentType.AML_PASSPORT, DocumentType.AML_CV, 
            DocumentType.AML_POLICIES, DocumentType.PAYMENT_INVOICE,

            DocumentType.GOOD_STANDING_CERTIFICATE_DOCUMENT, DocumentType.CONSTITUTION_DOCUMENT,
            DocumentType.MOST_RECENT_ACCOUNTS_DOCUMENT, DocumentType.SUPPORTING_DOCUMENTS_BY_REGULATOR


        ];
        return attachments.filter(i => !exludedTypes.includes(i.documentType));
    }
    
    groupByDocumentType(attachments: Attachment[]): AttachmentGroup[] {
        const map = attachments.reduce((acc, att) => {
        const type = att.documentType as DocumentType;

            if (!acc[type]) {
            acc[type] = [];
            }
            acc[type].push(att);
            return acc;
        }, {} as Record<DocumentType, Attachment[]>);

        const groups = Object.entries(map).map(([documentType, attachments]) => ({
            documentType: documentType as DocumentType,
            attachments,
        }));

        return groups.sort((a, b) => {
            if (a.documentType === DocumentType.APPLICATION_REPORT) return -1;
            if (b.documentType === DocumentType.APPLICATION_REPORT) return 1;
            return 0;
        });
    }

    getAttachmentsByIds(ids: number[]): Attachment[] {
        return this.attachments.filter(att => ids.includes(att.documentId));
    }

    downloadDocument(fileKey: string, fileName: string): Observable<Blob> {
        return this.http.getFile(`attachment/download?fileKey=${fileKey}&fileName=${fileName}`);
    }
}